import { StaticInterface } from '../../../helpers/static-interface';
import TpxCircleUtils from '../../atoms/shape/circle.utils';
import Lottie from 'lottie-web';
import { illustration } from './illustration';

export interface ITpxServicesUtils {
  loadLottie(parentEl: HTMLElement, json: Object): void;
}

export interface IStaticTpxServicesUtils {
  new(...args: any[]): ITpxServicesUtils;
  init(): void;
}

/**
 * Services organism functionality
 * @class
 */
export default class TpxServicesUtils implements StaticInterface<IStaticTpxServicesUtils, typeof TpxServicesUtils> {
  #element: HTMLElement;
  #images: HTMLElement[];
  #serviceLinks: HTMLElement[];

  /**
   * @constructor
   * @param {HTMLElement} element The services root element
   */
  constructor(element: HTMLElement) {
    this.loadLottie(element, illustration);

    this.#element = element;
    this.#images = [...this.#element.getElementsByClassName('o-services__image')].map(image => image as HTMLElement);
    this.#serviceLinks = [...this.#element.getElementsByClassName('o-services__service')].map(serviceLink => serviceLink as HTMLElement);

    if (this.#images.length > 1 && this.#serviceLinks.length > 1) {
      this.#addEventListeners();
    }
  }

  /**
     * Load lottie animations
     */
  loadLottie(parentEl: HTMLElement, json: Object): void {
    const container1 = parentEl.querySelector('[data-component="services-listing-block-animation-mobile"]');
    const container2 = parentEl.querySelector('[data-component="services-listing-block-animation-desktop"]');
    const prefersReducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

    if (container1 !== null) {
      const container = container1;
      //load the animation and autoplay it if user has not set prefers reduced motion on their device
      Lottie.loadAnimation({
        animationData: json,
        container,
        renderer: 'svg',
        loop: true,
        autoplay: !prefersReducedMotion,
      });
    }

    if (container2 !== null) {
      const container = container2;
      //load the animation and autoplay it if user has not set prefers reduced motion on their device
      Lottie.loadAnimation({
        animationData: json,
        container,
        renderer: 'svg',
        loop: true,
        autoplay: !prefersReducedMotion,
      });
    }

  }

  #addEventListeners() {
    this.#serviceLinks.forEach(serviceLink => {
      serviceLink.addEventListener('focus', evt => this.#changeImage(evt.target as HTMLElement));
      serviceLink.addEventListener('mouseenter', evt => this.#changeImage(evt.target as HTMLElement));
    });
  }

  #changeImage(serviceLink: HTMLElement) {
    const id = serviceLink.dataset.servicesImageId;

    const activeImage = this.#element.querySelector('.o-services__image--active');
    const newImage = this.#images.find(image => image.dataset.servicesImageId == id);

    if (!newImage || activeImage == newImage) {
      return;
    }

    activeImage?.classList.remove('o-services__image--active');
    newImage.classList.add('o-services__image--active');
  }

  /**
   * Creates new instances of TpxServicesUtils for each `.o-services` element,
   */
  static init() {
    const services: Element[] = [...document.getElementsByClassName('o-services')];
    services.forEach(service => {
      new TpxCircleUtils(service as HTMLElement);
      new TpxServicesUtils(service as HTMLElement);
    });
  }
}